<div class="project-item-container" (click)="project?.draft ? editproject(true) : clickProjectItem()">
  <div fxLayout="{{layout === 'grid' ? 'column' : 'row'}}" fxLayoutGap="24px"
       fxLayoutAlign="{{layout === 'grid' ? 'center center' : 'space-between center'}}" [ngStyle]="{width: '100%'}">
    <div class="image-holder" fxLayout="{{layout === 'grid' ? 'column' : 'row'}}"
         fxLayoutGap="{{layout === 'grid' ? '30px' : '20px'}}"
         fxLayoutAlign="{{layout === 'grid' ? 'center center' : 'space-between center'}}">
      <ng-container *ngIf="layout === 'grid'">
        <img class="logo" *ngIf="!project.logo || !project.logo.fileName" src="./assets/images/pkg-default.svg">
        <img class="logo" *ngIf="project && project.logo && project.logo.fileName" [src]="logoUrl">
      </ng-container>
      <ng-container *ngIf="layout === 'list'">
        <img class="cover-image" *ngIf="!project.logo || !project.logo.fileName"
             src="./assets/images/pkg-default.svg">
        <img class="cover-image" *ngIf="project && project.logo && project.logo.fileName" [src]="logoUrl">
      </ng-container>
      <div [ngStyle]="{textAlign: layout === 'grid' ? 'center' : 'left'}">
        <div style="font-size: 18px;font-weight: 600; color: #DEDEDE">{{project.name}}</div>
        <div style="font-size: 14px; color: #9E9BA2;margin-top: 4px;">
          {{project.addressLine1 ? project.addressLine1 : ''}} {{project.addressLine2}} {{project.area}}
          {{project.state}} {{project.postCode}}
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="flex align-center fz_14 mr_15"
           *ngIf="!project?.draft">
        <div style="width:5px;height:5px;border-radius:50%;background: #FFAA21;" class="{{satusShow}}bg"></div>
        <div [ngClass]="satusShow" style="margin-left: 5px;color: #FFAA21;">{{satusShow}}</div>
      </div>
      <div class="flex align-center fz_14 mr_15"
           *ngIf="project?.draft"
           style="width: 52px">
        <div style="width:5px;height:5px;border-radius:50%;background: grey;"></div>
        <div [ngClass]="satusShow" style="margin-left: 5px;color: grey;">Draft</div>
      </div>

      <div class="operate_box" *ngIf="project.showBox" (mouseleave)="project.showBox=false">
        <img src="./assets/images/black/black_close.png" class="black_close"
             (click)="project.showBox=false;$event.stopPropagation()">
        <!-- <div class="operate_text fz_14" (click)="project.showBox=false;$event.stopPropagation()">Add to
            favourites</div> -->
        <div class="operate_text fz_14" (click)="editproject();project.showBox=false;$event.stopPropagation()">
          Edit project
        </div>
        <div class="operate_text fz_14"
             (click)="openManulUpdateDialog();project.showBox=false;$event.stopPropagation()">Review
        </div>
      </div>
    </div>
  </div>
</div>
